import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";
import {
  CREATE_CERTIFICATION_IDENTIFIER,
  LIST_IDENTIFIER,
  LOADER_IDENTIFIER,
  TAB_SELECTED_IDENTIFIER,
} from "./constants";

const {
  STEP_ONE,
  STEP_TWO,
  SUPERVISORS,
  ADDED_SUPERVISORS,
  STEP_THREE,
  REVISORS,
  REVISOR_SELECTED,
  ADDED_APPLICATIONS,
  ADDED_BR,
  ADDED_GROUPS,
  ADDED_USERS,
  APPLICATIONS,
  BR,
  DESCRIPTION,
  DURATION,
  GROUPS,
  NAME,
  OPERATION,
  BAO_REVISOR,
  BR_INCLUDED,
  EVERY_DAY_COMPUTATION_ACTIVE,
  MANAGER_REVISOR_LOGIC_APPLIED,
  SEQUENCE,
  START_DATE,
  STEP_EIGHT,
  STEP_FIVE,
  STEP_FOUR,
  STEP_SEVEN,
  STEP_SIX,
  TOLERANCE,
  TYPE,
  USERS,
  VALIDATION,
  ADDED_ENTITLEMENTS,
  ENTITLEMENTS,
  STEP_NINE,
  CALL_STATE,
  CONFIRM_MODAL_TRIGGER,
  SELECTED_CERTIFICATION,
  ENRICHMENT_SELECTED_CERTIFICATION,
  ALREADY_SET,
  STEP_TEN,
  ADDED_TECHNCIAL_USERS,
  TECHNCIAL_USERS,
} = CREATE_CERTIFICATION_IDENTIFIER;

export default {
  [ALREADY_SET]: false,
  [CALL_STATE]: IResponseState.PENDING,
  [CONFIRM_MODAL_TRIGGER]: false,
  [SELECTED_CERTIFICATION]: null,
  [ENRICHMENT_SELECTED_CERTIFICATION]: null,
  [STEP_ONE]: {
    [NAME]: "",
    [DESCRIPTION]: "",
    [TYPE]: "",
    [OPERATION]: false,
    [VALIDATION]: false,
    [BAO_REVISOR]: false,
    [BR_INCLUDED]: false,
    [EVERY_DAY_COMPUTATION_ACTIVE]: false,
    [MANAGER_REVISOR_LOGIC_APPLIED]: false,
  },
  [STEP_TWO]: {
    [SUPERVISORS]: { [LIST_IDENTIFIER]: [], [LOADER_IDENTIFIER]: false },
    [ADDED_SUPERVISORS]: [],
  },
  [STEP_THREE]: {
    [REVISORS]: { [LIST_IDENTIFIER]: [], [LOADER_IDENTIFIER]: false },
    [REVISOR_SELECTED]: {},
  },
  [STEP_FOUR]: {
    [TOLERANCE]: 0,
    [START_DATE]: "",
    [DURATION]: 0,
    [SEQUENCE]: 0,
  },
  [STEP_FIVE]: {
    [GROUPS]: { [LIST_IDENTIFIER]: null, [LOADER_IDENTIFIER]: false },
    [ADDED_GROUPS]: [],
    [TAB_SELECTED_IDENTIFIER]: "WHITE",
  },
  [STEP_SIX]: {
    [USERS]: { [LIST_IDENTIFIER]: null, [LOADER_IDENTIFIER]: false },
    [ADDED_USERS]: [],
    [TAB_SELECTED_IDENTIFIER]: "WHITE",
  },
  [STEP_SEVEN]: {
    [APPLICATIONS]: { [LIST_IDENTIFIER]: null, [LOADER_IDENTIFIER]: false },
    [ADDED_APPLICATIONS]: [],
    [TAB_SELECTED_IDENTIFIER]: "WHITE",
  },
  [STEP_EIGHT]: {
    [BR]: { [LIST_IDENTIFIER]: null, [LOADER_IDENTIFIER]: false },
    [ADDED_BR]: [],
    [TAB_SELECTED_IDENTIFIER]: "WHITE",
  },
  [STEP_NINE]: {
    [ENTITLEMENTS]: { [LIST_IDENTIFIER]: null, [LOADER_IDENTIFIER]: false },
    [ADDED_ENTITLEMENTS]: [],
    [TAB_SELECTED_IDENTIFIER]: "WHITE",
  },
  [STEP_TEN]: {
    [TECHNCIAL_USERS]: { [LIST_IDENTIFIER]: null, [LOADER_IDENTIFIER]: false },
    [ADDED_TECHNCIAL_USERS]: [],
    [TAB_SELECTED_IDENTIFIER]: "WHITE",
  },
};
